import { FormContent, SummaryItem } from '../../components/bookingConfirmationCard/bookingConfirmationFun';
import { useEffect, useMemo, useRef, useState } from 'react';
import './bookingConfirmation.css';
import BookingConfirmationCard from '../../components/bookingConfirmationCard/bookingConfirmationCard';
import TitleBar from '../../components/titleBar/titleBar';
// import holidayImage from '../../assets/images/trvto_holiday.png';
import tripImage from '../../assets/images/trvto_trip.png';
import { ReactComponent as Download } from '../../assets/icons/trvto_download.svg';
import { getHikedPrice, getTaxAmount } from '../../utils/getAmountWithTransaction';
import { getFormattedDate, getFormattedOnlyDate } from '../../utils/formatDate';
import logo from '../../assets/images/trvto-logo.png';
import { getTotalSeatCount } from '../../utils/getTotalSeatCount';
import { calculatePaymentAll } from '../../utils/calculatePayment';
import { StayData, StaySummaryCard } from './StayConfirmation';

const TripData = ({ bookingData, userData, bookingId }) => {
    return (
        <BookingConfirmationCard
            title='Your Trip'
            imgSrc={localStorage.getItem('tripImage') || tripImage}
            imgAlt='trvto_trip'
            tripName={bookingData?.title}
        >
            <div className='innerFormContent'>
                <FormContent
                    label='Trip Date'
                    answer={getFormattedDate(new Date(bookingData?.date || bookingData.startDate))}
                />
                <FormContent label='Organizer Name' answer={bookingData?.organizerName} />
                <FormContent label='Travelers' answer={bookingData?.totalSeats} />
                <FormContent label='Days' answer={bookingData?.days} />
                <FormContent label='Name' answer={userData[0]?.name} />
                <FormContent label='Phone' answer={userData[0]?.phoneNumber} />
                <FormContent label='Email' answer={userData[0]?.emailId} />
                <FormContent label='Transport' answer={bookingData?.transport} />
                {bookingData.datesType === 'fixed' && bookingData.totalRooms > 0 ? (
                    <FormContent label='Rooms' answer={bookingData?.totalRooms} />
                ) : (
                    bookingData?.customTrip?.rooms?.length > 0 && (
                        <FormContent label='Rooms' answer={bookingData?.customTrip?.rooms?.length} />
                    )
                )}
                {Number(bookingData?.customTrip?.bed || 0) > 0 && (
                    <FormContent label='Extra Beds' answer={bookingData?.customTrip?.bed} />
                )}
                {bookingData?.customTrip?.vehicle?.length > 0 && (
                    <FormContent
                        label='Vehicle'
                        answer={bookingData.customTrip?.vehicle
                            .map((v) => `${v.vehicleName}: ${v.vehicleCount}`)
                            .join(', ')}
                    />
                )}
                {bookingData.group === 'vehicle' && (
                    <>
                        <FormContent label='Vehicle' answer={bookingData?.vehicle?.mode} />
                        {bookingData?.vehicle?.model && (
                            <FormContent label='Vehicle Model' answer={bookingData?.vehicle?.model} />
                        )}
                        {bookingData?.vehicle?.comfortable === 'Yes' && (
                            <FormContent label='Empty Seats' answer={bookingData?.vehicle?.emptySeats} />
                        )}
                    </>
                )}
                <FormContent label='Start City' answer={bookingData?.startCity} />
                <FormContent
                    label='Pickup/Meetup Location'
                    answer={bookingData?.pickupLocation || bookingData?.meetupPoint}
                />
                <FormContent label='Booking ID' answer={bookingId} />
            </div>{' '}
        </BookingConfirmationCard>
    );
};

const GuData = ({ bookingData, userData, bookingId }) => {
    return (
        <BookingConfirmationCard
            title='Your Guide'
            imgSrc={localStorage.getItem('tripImage') || tripImage}
            imgAlt='trvto_trip'
            tripName={bookingData?.title}
        >
            <div className='innerFormContent'>
                <FormContent
                    label='Guide Date'
                    answer={getFormattedOnlyDate(new Date(bookingData?.date || bookingData.startDate))}
                />
                <FormContent label='Organizer Name' answer={bookingData?.organizerName} />
                <FormContent label='Travelers' answer={bookingData?.seatsCount || bookingData?.people} />
                <FormContent
                    label='TimeSlot'
                    answer={`${bookingData?.timeSlots?.startTime} - ${bookingData?.timeSlots?.endTime}`}
                />
                <FormContent label='Place' answer={`${bookingData?.place?.name}`} />
                {bookingData?.meetupLocation && (
                    <FormContent label='Meetup Point' answer={bookingData?.meetupLocation.name} />
                )}
                <FormContent label='Name' answer={userData[0]?.name} />
                <FormContent label='Phone' answer={userData[0]?.phoneNumber} />
                <FormContent label='Email' answer={userData[0]?.emailId} />
                {/* <FormContent label='Transport' answer={bookingData?.transport} /> */}
                {/* <FormContent label='Location' answer={bookingData?.startCity} /> */}
                {/* <FormContent label='Meetup Location' answer={bookingData?.pickupLocation || bookingData?.meetupPoint} /> */}
                <FormContent label='Booking ID' answer={bookingId} />
            </div>{' '}
        </BookingConfirmationCard>
    );
};

const ActData = ({ bookingData, userData, bookingId }) => {
    return (
        <BookingConfirmationCard
            title='Your Activity'
            imgSrc={localStorage.getItem('tripImage') || tripImage}
            imgAlt='trvto_trip'
            tripName={bookingData?.title}
        >
            <div className='innerFormContent'>
                <FormContent
                    label='Activity Date'
                    answer={getFormattedOnlyDate(new Date(bookingData?.date || bookingData.startDate))}
                />
                <FormContent label='Organizer Name' answer={bookingData?.organizerName} />
                <FormContent label='Travelers' answer={getTotalSeatCount(bookingData?.totalSeats)} />
                <FormContent
                    label='TimeSlot'
                    answer={`${bookingData?.timeSlots?.startTime} - ${bookingData?.timeSlots?.endTime}`}
                />
                <FormContent label='Name' answer={userData[0]?.name} />
                <FormContent label='Phone' answer={userData[0]?.phoneNumber} />
                <FormContent label='Email' answer={userData[0]?.emailId} />
                {/* <FormContent label='Start City' answer={bookingData?.startCity} /> */}
                {bookingData?.meetupLocation && (
                    <FormContent label='Meetup Location' answer={bookingData?.meetupLocation.name} />
                )}
                <FormContent label='Booking ID' answer={bookingId} />
            </div>
        </BookingConfirmationCard>
    );
};
const BookingConfirmation = () => {
    const [bookingData, setBookingData] = useState({});
    const [userData, setUserData] = useState([]);
    const [bookingId, setBookingId] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [type, setType] = useState('');
    const paymentBreakdown = JSON.parse(localStorage.getItem('paymentBreakdown'));
    const paymentPrices = useMemo(() => {
        return calculatePaymentAll({ bookingData, paymentType });
    }, [bookingData, paymentType]);

    const { sub_total, tax, offerAmount, convenienceFee, total, roomPrice, remainingAmount, discount, vehiclePrice } =
        paymentPrices;
    useEffect(() => {
        const storedData = localStorage.getItem('backendBookingData');
        if (storedData) {
            const parsedData = JSON.parse(storedData);

            setBookingData(parsedData);
            setUserData(parsedData?.userDetails);
            setType(parsedData?.type);
            setBookingId(parsedData?._id);
            setPaymentType(localStorage.getItem('paymentType'));
        }
    }, []);

    const firedRef = useRef(false);

    useEffect(() => {
        // if (!firedRef.current && window.fbq && bookingData?.amountPaid?.total) {
        if (!firedRef.current && window.fbq) {
            window.fbq('track', 'Purchase', {
                value: bookingData?.amountPaid?.total || 1000,
                currency: 'INR'
            });
            firedRef.current = true; // prevent double firing
        }
    }, [bookingData]);
    return (
        <>
            <TitleBar title='Booking Confirmed' />
            <div className='manageOrder mb-2'>
                <div className='customContainer'>
                    <div className='cardContainer'>
                        <div className='printOnly'>
                            <img src={logo} alt='trvto logo' className='headerLogoImg'></img>
                        </div>

                        {type === 'trip' && (
                            <TripData bookingData={bookingData} userData={userData} bookingId={bookingId} />
                        )}
                        {type === 'act' && (
                            <ActData bookingData={bookingData} userData={userData} bookingId={bookingId} />
                        )}
                        {type === 'gu' && (
                            <GuData bookingData={bookingData} userData={userData} bookingId={bookingId} />
                        )}
                        {type === 'camp' && (
                            <StayData bookingData={bookingData} userData={userData} bookingId={bookingId} />
                        )}

                        {type === 'camp' ? (
                            <StaySummaryCard bookingData={bookingData} />
                        ) : (
                        <div className='card rightCard'>
                            <p className='title font24'>Summary</p>
                            <div className='summaryContent'>
                                {bookingData?.isReserved ||
                                bookingData?.isInstallment ||
                                bookingData?.amountPaid?.isReserved ||
                                bookingData?.amountPaid?.isInstallment ? (
                                    <>
                                        <SummaryItem label='Sub Total' amount={`₹${sub_total}`} />
                                        <SummaryItem label='Convinience Fee' amount={`+ ₹${convenienceFee}`} />
                                        {paymentType === 'UPI' && (
                                            <SummaryItem label='UPI Offer' amount={`- ₹${convenienceFee}`} />
                                        )}
                                        <SummaryItem label='Total' amount={`₹${total}`} isTotal={true} />
                                    </>
                                ) : (
                                    <>
                                        <SummaryItem label='Sub Total' amount={`₹${sub_total}`} />
                                        {!bookingData.isReserved &&
                                            !bookingData.isInstallment &&
                                            bookingData.totalRooms > 0 && (
                                                <SummaryItem label='Room' amount={`+ ₹${roomPrice} `} />
                                            )}
                                        {vehiclePrice > 0 && (
                                            <SummaryItem label='Vehicle' amount={`+ ₹${vehiclePrice} `} />
                                        )}
                                        <SummaryItem label='Discount' amount={`- ₹${discount}`} />

                                        {bookingData?.amountPaid?.offerAmount > 0 && (
                                            <SummaryItem label='Offer' amount={`- ₹${offerAmount}`} />
                                        )}
                                        <SummaryItem label='Convinience Fee' amount={`+ ₹${convenienceFee}`} />
                                        {paymentType === 'UPI' && (
                                            <SummaryItem label='UPI Offer' amount={`- ₹${convenienceFee}`} />
                                        )}
                                        {/* {!bookingData.isReserved && !bookingData.isInstallment && (
                                            <SummaryItem
                                                label='Tax'
                                                amount={`+ ₹${bookingData?.amountPaid?.tax || getTaxAmount(bookingData?.peopleAmo || bookingData?.amountPaid?.total)} `}
                                            />
                                        )} */}
                                        <SummaryItem label='Tax' amount={`+ ₹${tax} `} />
                                        <SummaryItem label='Total' amount={`₹${total}`} isTotal={true} />
                                    </>
                                )}
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                {(bookingData.isReserved || bookingData?.amountPaid?.isReserved) && (
                                    <div className='leftAmountDiv'>
                                        Remaining amount to be paid on the trip Rs.
                                        {remainingAmount} (including tax)
                                    </div>
                                )}
                            </div>
                            <button className='floatingPrintButton hideOnPrint' onClick={() => window.print()}>
                                <Download /> Download
                            </button>
                        </div>
                        )}
                    </div>
                </div>
                {/* <div className="customContainer" style={{ marginTop: '24px' }}>
                    <div className="cardContainer">
                        <BookingConfirmationCard
                            title="Holiday Packages"
                            imgSrc={holidayImage}
                            imgAlt="trvto_holiday"
                            tripName="Jeju Island"
                            reviews={{ rating: '4.5', count: '237' }}
                        >
                            <FormContent
                                label="Dates"
                                answer="10 August, 2024 - 16 August, 2024"
                            />
                            <div className="innerFormContent">
                                <FormContent
                                    label="Pickup Timings"
                                    answer="11:00 AM"
                                />
                                <FormContent label="Guests" answer="2" />
                            </div>
                            <div className="innerFormContent">
                                <FormContent label="Type" answer="Holiday" />
                                <FormContent label="Stay" answer="5 Days" />
                            </div>
                            <div className="innerFormContent">
                                <FormContent label="Food" answer="Yes" />
                                <FormContent
                                    label="Transport"
                                    answer="Indigo Air"
                                />
                            </div>
                            <FormContent
                                label="Pickup Location"
                                answer="2464 Royal Ln. Mesa, New Jersey 45463"
                            />
                            <FormContent
                                label="Organizer Name"
                                answer="Jaane Cooper"
                                className="borderNone"
                            />
                        </BookingConfirmationCard>
                    </div>
                </div> */}
            </div>
        </>
    );
};

export default BookingConfirmation;
